/* global define:false */

/**
Check whether an element is intirely or partially in the document viewport or not

@method transformImage
@param {String} path the pathname of the image e.g.: my_img.png
@param {Object} options 
@param {string} root the url root. default: https://media.surveyplanet.com
*
*/
(function(root, factory) {

	if (typeof define === 'function' && define.amd) {
		// AMD (require.js)
		return define('transform_image',['cloudinary'], factory);
	} else if (typeof module === 'object' && module.exports) {
		// CommonJS (Node.js)
		return module.exports = factory( require('cloudinary-core') );
	} else {
		// Browser globals (root is window)
		return root.transformImage = factory(root.cloudinary);
	}

})(this, function(cloudinary) {

	var BUCKET = 'surveyplanet-media';
	var ROOT_URL = 'https://media.surveyplanet.com';
	// var ROOT_URL_CLOUDINARY = 'https://res.cloudinary.com/surveyplanet';
	var CLOUDINARY_REGEX = /^.+\.cloudinary\.com\/(?:[^/]+\/)(?:(image|video|raw)\/)?(?:(upload|fetch|private|authenticated|sprite|facebook|twitter|youtube|vimeo)\/)?(?:(?:[^_/]+_[^,/]+,?)*\/)?(?:v(\d+|\w{1,2})\/)?([^.^\s]+)(?:\.(.+))?$/;

	function extractCloudinaryImageName (link) {

		if (!link) {
			return '';
		}

		var parts = CLOUDINARY_REGEX.exec(link);

		return parts && parts.length > 2 ? parts[parts.length - 2] : link;
	} 


	// convert surveyplanet options to cloudinary options
	function parseCloudinaryOptions (options) {

		if (!options) {
			options = {};
		}


		if(options.resize) {

			// https://cloudinary.com/documentation/image_transformations#resizing_and_cropping_images
			if (options.resize.fit) {
				switch (options.resize.fit) {
				case 'cover':
					options.crop = 'fill';
					break;
				case 'contain':
					options.crop = 'pad';
					break;
				case 'fill':
					options.crop = 'scale';
					break;
				case 'inside':
					options.crop = 'fit'; 
					break;
				case 'outside':
					options.crop = 'fit'; // no coronation
					break;
				}
			}

			if (options.resize.width) {
				options.width = options.resize.width;
			}

			if (options.resize.height) {
				options.height = options.resize.height;
			}

			if (options.resize.background) {
				// cloudinary doesn't support colors in RGB so just make it white
				options.background = 'white';
			}

			if (options.resize.dpr) {
				options.dpr = options.resize.dpr;
			}

			delete options.resize;
		}

		if (options.roundCrop) {
			options.radius = 'max';
			delete options.roundCrop;
		}

		if (options.smartCrop) {
			options.gravity = 'face';
			options.crop = 'thumb';
			delete options.smartCrop;
		}

		options.secure = true;

		return options;
	}

	function transformImage(url, args) {

		if (!args) {
			args = {};
		}


		// clone args, this should be ok since there shouldn't be any functions
		var options = JSON.parse(JSON.stringify(args));

		var image,
			returnImgTag = false,
			imgTagAlt;

		if (options.html) {
			returnImgTag = true;
			imgTagAlt = options.alt;
			delete options.alt;
			delete options.html;
		}

		// ensure width and height are nice round numbers
		if (options.resize) {
			if ( options.resize.width ) {
				options.resize.width = Math.ceil(options.resize.width);
			}
			if ( options.resize.height )  {
				options.resize.height = Math.ceil(options.resize.height);
			}
		}
		
		if ( url.substring(0, ROOT_URL.length) === ROOT_URL ) {

			if (Object.entries(args).length === 0) {
				return url;
			}

			var originalWidth = options.resize.width;
			var originalHeight = options.resize.height;

			if (options.resize && options.resize.dpr) {
				if (options.resize.width) {
					options.resize.width = Math.ceil(options.resize.width * options.resize.dpr);
				}
				if (options.resize.height) {
					options.resize.height = Math.ceil(options.resize.height * options.resize.dpr);
				}
				delete options.resize.dpr;
			}

			// default content moderation
			if ( options.contentModeration && options.contentModeration === true) {
				options.contentModeration = {
					minConfidence: 75,
					blur: 50,
					moderationLabels: [
						'Hate Symbols',
						'Explicit Nudity'
					],
				};					
			}

			var stringified = JSON.stringify({
				bucket: BUCKET,
				key: url.replace(ROOT_URL+'/', ''),
				edits: options
			});

			var ascii;

			// convert arguments from binary to (base64 encoded) ascii
			if (typeof btoa !== 'undefined' && btoa !== null) {
				//  browser
				ascii = btoa(stringified);
			} else if (typeof Buffer !== 'undefined' && Buffer !== null) {
				// node.js
				ascii = Buffer.from(stringified, 'binary').toString('base64');
			}

			if (!ascii) {
				return url;
			}

			image = ROOT_URL+'/'+ascii;

			if (returnImgTag) {

				image = '<img src="' + image + '"';

				if (options.resize) {
					
					if (options.resize.width) {
						image += ' width="'+originalWidth+'"';
					}
	
					if (options.resize.height) {
						image += ' height="'+originalHeight+'"';
					}

				}

				if (imgTagAlt) {
					image += ' alt="'+imgTagAlt+'"';
				}

				image += '>';

			}

			return image;
		
		}
		
		// Legacy Cloudinary support.
		// if ( url.substring(0, ROOT_URL_CLOUDINARY.length) === ROOT_URL_CLOUDINARY ) {
		if ( CLOUDINARY_REGEX.test(url) ) {

			if (Object.entries(args).length === 0 && !(/\.gif$/.test(url)) ) {
				return url;
			}

			if (!cloudinary) {
				throw new Error('Must import cloudinary library (cloudinary-core-shrinkwrap.js is recomended). Try `npm install cloudinary-core`. ');
			}

			// console.log(url);

			if (!cloudinary || !cloudinary.Cloudinary) {
				return url;
			}
 
			var transfromer = cloudinary.Cloudinary.new({
				cloud_name: 'surveyplanet'
			});

			var imgName = extractCloudinaryImageName(url);
			// console.log(imgName);
			options = parseCloudinaryOptions(options);

			if (/\.gif$/.test(url)) {
				options.format = 'png';
			}

			if (returnImgTag) {
				image = transfromer.imageTag(imgName, options).toHtml();
			} else {
				image = transfromer.url(imgName, options);
			}

			return image;

		}

		// console.log('NO TRANSFORMATION');

		return url;

	}

	return transformImage;

});




